export default {
  org: {
    Type: 'Type',
    Parent: 'Parent',
    ParentName: 'Parent Name',
    SearchByName: 'Search By Name',
    ChooseParent: 'Choose Parent',
    EditParent: 'Edit Parent'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/base/org.js